import React, { useState } from "react";
import { Input } from "@/components/erp/ui";
import { X } from "lucide-react";

const DAYS = ["Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu", "Minggu"];

export const ScheduleEditor = ({ value, onChange, dis }) => (
  <div className="rounded-lg border border-slate-200 divide-y divide-slate-100" data-testid="schedule-editor">
    {DAYS.map((d, i) => {
      const v = value[String(i)] || { off: false, start: "08:00", end: "17:00" };
      const set = (p) => onChange({ ...value, [String(i)]: { ...v, ...p } });
      return (
        <div key={d} className="flex items-center gap-3 px-3 py-2 text-sm flex-wrap" data-testid={`sched-day-${i}`}>
          <span className="w-16 font-medium">{d}</span>
          <label className="flex items-center gap-1 text-xs"><input type="checkbox" disabled={dis} data-testid={`sched-off-${i}`} checked={v.off} onChange={(e) => set({ off: e.target.checked })} /> Libur</label>
          {!v.off && <div className="flex items-center gap-2">
            <Input type="time" disabled={dis} className="w-28 border border-slate-300 rounded-lg px-2 py-1.5 text-sm" data-testid={`sched-start-${i}`} value={v.start} onChange={(e) => set({ start: e.target.value })} />
            <span className="text-slate-400">–</span>
            <Input type="time" disabled={dis} className="w-28 border border-slate-300 rounded-lg px-2 py-1.5 text-sm" data-testid={`sched-end-${i}`} value={v.end} onChange={(e) => set({ end: e.target.value })} />
          </div>}
        </div>
      );
    })}
  </div>
);

export const DateChips = ({ value, onChange, dis, testid }) => {
  const [d, setD] = useState("");
  const add = () => { if (d && !value.includes(d)) onChange([...value, d].sort()); setD(""); };
  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1.5 mb-2">
        {value.map((x) => (
          <span key={x} className="inline-flex items-center gap-1 text-xs bg-slate-100 rounded-full px-2 py-0.5" data-testid={`${testid}-chip-${x}`}>
            {x}{!dis && <button type="button" onClick={() => onChange(value.filter((y) => y !== x))}><X className="w-3 h-3 text-slate-400 hover:text-rose-500" /></button>}
          </span>
        ))}
        {value.length === 0 && <span className="text-xs text-slate-400">Belum ada tanggal</span>}
      </div>
      {!dis && <div className="flex gap-2"><Input type="date" className="w-44" data-testid={`${testid}-input`} value={d} onChange={(e) => setD(e.target.value)} />
        <button type="button" data-testid={`${testid}-add`} onClick={add} className="px-3 rounded-lg border border-slate-300 text-sm">Tambah</button></div>}
    </div>
  );
};
